// extracted by mini-css-extract-plugin
export default {"summaryContent":"SignUpCard-styles__summaryContent__WMwXC","expandedContent":"SignUpCard-styles__expandedContent__UZur9"};